/**
 * C 端路由默认值（构建时由 .env 中 VUE_APP_* 注入）
 */

const DEFAULT_ROOT_REDIRECT = '/ja/m/bookclass'

/** localeRoutes 中已注册的 name，用于 /{locale} 空路径重定向 */
const LOCALE_INDEX_NAMES = new Set([
  'home',
  'register',
  'login',
  'feadback',
  'bookclass',
  'mobileHome',
  'mobileLogin',
  'mobileRegister',
  'mobileBookclass',
  'mobileBookRank',
  'bookRank',
  'book',
  'mobileBook',
  'mobileBookContent',
  'mobileChapterList',
  'chapterList',
  'bookContent',
  'userSetup',
  'mobileUserSetup',
  'recharge',
  'bookshelf',
  'mobileRecharge',
  'mobileBookshelf',
  'mobileMember',
  'member',
  'paymentResult',
  'mobilePaymentResult',
])

/**
 * 访问站点根路径（如 #/）时的完整重定向路径，须以 /zh 或 /ja 开头
 */
export function getRootRedirectPath () {
  const raw = process.env.VUE_APP_ROOT_REDIRECT
  if (!raw || typeof raw !== 'string' || !String(raw).trim()) {
    return DEFAULT_ROOT_REDIRECT
  }
  let p = String(raw).trim()
  if (!p.startsWith('/')) p = `/${p}`
  if (!/^\/(zh|ja)(\/|$)/.test(p)) {
    return DEFAULT_ROOT_REDIRECT
  }
  return p.replace(/\/+/g, '/')
}

/**
 * 访问 /{locale} 且子 path 为空时的路由 name（如 mobileBookclass、home）
 */
export function getLocaleIndexRouteName () {
  const raw = process.env.VUE_APP_LOCALE_INDEX_NAME
  const name = raw && typeof raw === 'string' ? raw.trim() : 'mobileBookclass'
  return LOCALE_INDEX_NAMES.has(name) ? name : 'mobileBookclass'
}
